import { normaliseRotation } from "@iventis/utilities";
import { SystemDataFieldName } from "@iventis/domain-model/model/systemDataFieldName";
import { DataField } from "@iventis/domain-model/model/dataField";
import { StyleType } from "@iventis/domain-model/model/styleType";
import { CompositionMapObject, TypedFeature } from "../types/internal";
import { MapModuleLayer } from "../types/store-schema";

/**
 * Applies rotation to a map object, handling both icon rotation data field and rotation property approaches
 * @param feature The GeoJSON feature to apply rotation to
 * @param object The composition map object containing layer and object IDs
 * @param angle The angle to apply in degrees
 * @param projectDataFields Array of project data fields to find icon rotation field
 * @returns Updated CompositionMapObject with applied rotation
 */
export function applyRotationToMapObject(
    feature: TypedFeature,
    object: CompositionMapObject,
    angle: number,
    projectDataFields: DataField[],
    layer: MapModuleLayer
): CompositionMapObject {
    if (layer.styleType === StyleType.Icon) {
        const iconRotationDatafieldId = projectDataFields.find((df) => df.systemDataFieldName === SystemDataFieldName.IconRotation)?.id;

        if (iconRotationDatafieldId != null) {
            const rotation: number = (feature.properties[iconRotationDatafieldId] as number) ?? 0;
            return {
                geojson: { ...feature, properties: { ...feature.properties, [iconRotationDatafieldId]: normaliseRotation(rotation + angle, 2) } },
                layerId: object.layerId,
                objectId: object.objectId,
                waypoints: undefined,
            };
        }
        // eslint-disable-next-line no-console
        console.error("Icon rotation data field not found, cannot apply rotation to icon");
        return { geojson: feature, layerId: object.layerId, objectId: object.objectId, waypoints: undefined };
    }

    const { rotation } = feature.properties;
    return {
        geojson: { ...feature, properties: { ...feature.properties, rotation: { ...rotation, z: rotation.z - angle } } },
        layerId: object.layerId,
        objectId: object.objectId,
        waypoints: undefined,
    };
}
